<div class="loading-container" *ngIf="isLoading" role="status" aria-live="polite" data-test="folder-picker-loading">
    <mat-spinner diameter="32"></mat-spinner>
    <span class="loading-text">Loading folders</span>
</div>

<p class="load-error" *ngIf="hasFailed && !isLoading" role="alert" data-test="folder-picker-error">
    Couldn't load your document folders.
    <button type="button" class="link-btn" (click)="load()">Try again</button>
</p>

<ng-container *ngIf="!isLoading && !hasFailed">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
        <i class="ph-bold ph-magnifying-glass icon-muted icon-16" matIconPrefix aria-hidden="true"></i>
        <input matInput
               type="text"
               [attr.aria-label]="'Search folders'"
               placeholder="Search folders"
               [ngModel]="searchQuery"
               (ngModelChange)="onSearchChange($event)"
               data-test="folder-picker-search">
        <i *ngIf="searchQuery"
           class="ph-bold ph-x icon-muted icon-16 clear-icon"
           matIconSuffix
           role="button"
           tabindex="0"
           aria-label="Clear search"
           (click)="clearSearch()"
           (keydown.enter)="clearSearch()"></i>
    </mat-form-field>

    <div class="folder-tree-container" data-test="folder-picker-tree">
        <tree-root #tree
                   [nodes]="nodes"
                   [options]="options"
                   (initialized)="onTreeInitialized()"
                   (activate)="onNodeClick($event)">
            <ng-template #treeNodeWrapperTemplate let-node let-index="index">
                <div class="tree-item"
                     [class.selected]="node.isActive"
                     [attr.data-test]="'folder-node-' + node.id"
                     (click)="node.mouseAction('click', $event)">
                    <tree-node-expander [node]="node" class="tree-toggle"></tree-node-expander>
                    <i class="ph-bold ph-folder icon-16 folder-icon" aria-hidden="true"></i>
                    <span class="folder-name">{{ node.data.fileName }}</span>
                </div>
            </ng-template>
        </tree-root>
    </div>

    <div class="path-preview" *ngIf="showPathPreview" [class.empty]="!hasSelection" data-test="folder-picker-path">
        <i class="ph-bold ph-folder icon-16 path-icon" aria-hidden="true"></i>
        <span class="path-text">
            <ng-container *ngIf="hasSelection">{{ pathDisplay }}</ng-container>
            <ng-container *ngIf="!hasSelection">Select a folder above</ng-container>
        </span>
    </div>
</ng-container>
